<template>
  <v-btn
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component', schema.attributesButton.class]"
    :name="schema.model"
    :id="generateId(schema.model)"
    :key="generateId(schema.model)"
    v-bind="schema.attributesButton"
    :disabled="schema.readonly"
    @click="execute"
  >
    <v-icon v-if="schema.attributesIcon && schema.attributesIcon.showIconLeft" v-bind="schema.attributesIcon">
      {{ schema.attributesIcon.icon }}
    </v-icon>
    {{ schema.attributesButton.label }}
    <v-icon v-if="schema.attributesIcon && schema.attributesIcon.showIconRight" v-bind="schema.attributesIcon">
      {{ schema.attributesIcon.icon }}
    </v-icon>
  </v-btn>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import * as HANDLERS from '@/helpers/types/handlers';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, componentMixin],

  created() {
    console.error('Componente está obsoleto, favor migrar para o componente i4proGroupButton.');
  },

  methods: {
    execute() {
      this.$emit(HANDLERS.EXECUTE_ACTION, { action: this.schema, origin: this.formOptions.page });
    },
  }
};
</script>
